import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { Snackbar, Alert, CircularProgress } from "@mui/material";

const EditReferralPage = () => {
  const location = useLocation(); // Get the state passed via navigation
  const referralToEdit = location.state?.referral; // Extract the referral data passed via state
  // console.log("referralToEdit", location.state);
  const [formValues, setFormValues] = useState({
    title: "",
    amount: "",
    description: "",
    status: 1,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [formError, setFormError] = useState("");
  const [touched, setTouched] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const navigate = useNavigate();

  useEffect(() => {
    if (referralToEdit) {
      // If referral data exists in state, populate form fields
      setFormValues({
        title: referralToEdit.title || "",
        amount: referralToEdit.amount || "",
        description: referralToEdit.description || "",
        status: referralToEdit.status || 1,
      });
    } else {
      setError("No referral data found.");
      setSnackbarOpen(true);
    }
  }, [referralToEdit]);

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        return;
      }

      const response = await axios.put(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/update-referrals/${referralToEdit._id}`,
        formValues,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.data.success) {
        setSnackbarMessage("Updated successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
        setTimeout(() => {
          navigate("/referrals-list"); // Redirect to referral list page
        }, 2000);
      } else {
        setFormError(response.data.message);
      }
    } catch (err) {
      setLoading(false);
      if (err.response && err.response.status === 400) {
        setSnackbarMessage("Please fill out all required fields...");
        setSnackbarSeverity("warning");
        setOpenSnackbar(true);
      } else {
        setSnackbarMessage("Error updating referral. Please try again.");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
      }
    }
  };

  return (
    <div className="row gy-4">
      <div className="col-lg-8" style={styles.cardContent(loading)}>
        <div className="card h-100">
          <div className="card-body p-24">
            {/* <h6 className="text-md text-primary-light mb-16">
              Edit Referral
            </h6> */}

            <form onSubmit={(e)=>handleFormSubmit(e)}>
              {/* Description */}
              <div className="mb-24">
                <label
                  htmlFor="title"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Title <span className="text-danger-600">*</span>
                </label>
                <input
                  className="form-control radius-8"
                  id="title"
                  // readOnly
                  placeholder="Enter Title"
                  value={formValues.title}
                  onChange={(e) =>
                    setFormValues({ ...formValues, title: e.target.value })
                  }
                />
              </div>

              {/* Description */}
              <div className="mb-24">
                <label
                  htmlFor="description"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Description <span className="text-danger-600">*</span>
                </label>
                <textarea
                  className="form-control radius-8"
                  id="description"
                  // readOnly
                  placeholder="Enter Description"
                  value={formValues.description}
                  onChange={(e) =>
                    setFormValues({ ...formValues, description: e.target.value })
                  }
                />
              </div>
  
              {/* Amount Paid */}
              <div className="mb-24">
                <label
                  htmlFor="amount"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Amount in $<span className="text-danger-600">*</span>
                </label>
                <input
                  type="number"
                  className="form-control radius-8"
                  id="amount"
                 
                  placeholder="Enter Amount"
                  value={formValues.amount}
                  
                  onChange={(e) =>
                    setFormValues({ ...formValues, amount: e.target.value })
                  }
                  required
                />
              </div>
  
              {/* Action Buttons */}
              <div className="d-flex align-items-center justify-content-between gap-3">
                <button
                  type="button"
                  className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-56 py-11 radius-8"
                  onClick={() => navigate("/referrals-list")}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                  // onClick={handleFormSubmit}
                  disabled={loading}
                >
                  {loading && (
                    <div className="loader-container" style={styles.loaderContainer}>
                      <CircularProgress />
                    </div>
                  )}
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Snackbar */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

// Add CSS for loader
const styles = {
  loaderContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
  },
  cardContent: (loading) => ({
    opacity: loading ? 0.5 : 1,
  }),
};

export default EditReferralPage;
